export const buildAshbyLink = (mergeRemoteId: string): string => {
  return `https://app.ashbyhq.com/candidate-searches/new/right-side/candidates/${mergeRemoteId}`;
};
